export default "__VITE_ASSET__B$I6KR0o__"